function supressCogoToastWarning() {
  // Due to cogo toast using older version of react code a warning is logged to
  // console mentioning to use ReactDOM.createRoot instead of ReactDOM.render.
  // Because there is nothing we can do about it we are skipping the error from
  // being raise using the below hack.

  if (window.console && console.error) {
    const ce = console.error;
    console.error = function () {
      if (
        typeof arguments[0] === 'string' &&
        arguments[0].startsWith(
          'Warning: ReactDOM.render is no longer supported in React 18. Use createRoot instead.'
        )
      ) {
        return;
      }

      ce.apply(this, arguments);
    };
  }
}

export default supressCogoToastWarning;
